"use strict";
'kiwi public';

/** @module */

/**
 * Adds a client-to-client "seen" (read receipt) signal to irc-framework.
 *
 * Read positions are shared between the two users of a private conversation
 * using the IRCv3 message-tags capability: a TAGMSG message is sent to the
 * other user carrying a `+kiwi/seen` tag whose value is the server-time of the
 * last message that user has read in the conversation. Eg.
 *
 *      TAGMSG othernick +kiwi/seen=2026-10-31T12:34:56.789Z
 *
 * This does not use the draft/read-marker spec (MARKREAD) as that only
 * syncs read state between a single users own clients and is never relayed
 * between different users.
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEEN_TAG = void 0;
exports.default = seenMiddleware;
var SEEN_TAG = exports.SEEN_TAG = '+kiwi/seen';
function seenMiddleware() {
  return function middleware(client, rawEvents, parsedEvents) {
    addFunctionsToClient(client);
    rawEvents.use(theMiddleware);
  };
  function theMiddleware(command, message, rawLine, client, next) {
    if (command === 'TAGMSG' && message.tags && message.tags[SEEN_TAG] && message.nick) {
      // If params[0] is us, the read mark is from the other user of the
      // conversation (direct message). Otherwise it is our own mark being
      // echoed around and is sent with fromPeer=false.
      var fromPeer = message.params[0].toLowerCase() === client.user.nick.toLowerCase();
      client.emit('seen', {
        nick: message.nick,
        ident: message.ident,
        hostname: message.hostname,
        fromPeer: fromPeer,
        timestamp: message.tags[SEEN_TAG]
      });
    }
    next();
  }
}
function addFunctionsToClient(client) {
  var seen = client.seen = {};

  // TAGMSG messages are only relayed when both clients and server negotiate
  // the message-tags capability
  seen.isSupported = function isSupported() {
    return !!(client.network && client.network.cap && client.network.cap.isEnabled('message-tags'));
  };

  // Tell the other user that we have read messages in the conversation up to
  // the given server-time timestamp
  seen.mark = function mark(target, serverTime) {
    if (!seen.isSupported()) {
      return;
    }
    var message = new client.Message('TAGMSG', target);
    message.tags[SEEN_TAG] = serverTime;
    client.raw(message);
  };
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["SeenMiddleware"]
window._kiwi_exports.libs.SeenMiddleware = exports.default ? exports.default : exports;
